import { render, staticRenderFns } from "./mentorlist.vue?vue&type=template&id=74a5bc9b&scoped=true"
import script from "./mentorlist.vue?vue&type=script&lang=js"
export * from "./mentorlist.vue?vue&type=script&lang=js"
import style0 from "./mentorlist.vue?vue&type=style&index=0&id=74a5bc9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5bc9b",
  null
  
)

export default component.exports